import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { CommonIcon } from "../../Utils/CommonIcon";

export default function PasswordInputField(props) {
  const [isViewPass, setIsViewPass] = useState(false);

  return (
    <div className="user-box field">
      <label>Password</label>
      <input
        name={props.name}
        placeholder="Password *"
        onChange={(e) => props.onChange(e)}
        value={props.value || ""}
        type={isViewPass ? "password" : "text"}
        id="password"
        required=""
        size={"small"}
      />
      <span className="password-toggle-icon">
        <Icon
          onClick={() => setIsViewPass(!isViewPass)}
          icon={isViewPass ? CommonIcon.eye : CommonIcon.visibility_off}
        />
      </span>
    </div>
  );
}
